module.exports = {
  // baseurl: "/cp-admin/",
  // serverPath: "https://espsofttech.org:7979/api/admin",
  // imageUrl : "https://espsofttech.org:7979/api/admin/uploads/",
  // flgImageUrl : "https://espsofttech.org:7979/api/admin/uploads/flag/",
  //serverPath:"http://localhost:8000/api/admin"

  //client server 
  baseurl: "/apurva_elec/",
  // serverPath: "http://localhost:8000/api/admin",
  // imageUrl : "http://localhost:8000/api/admin/public/",

    serverPath: "https://aptitrading.com/api/admin",
    imageUrl : "https://aptitrading.com/api/admin/public/",

  flgImageUrl : "https://4you.com.kz/media/",
  //  serverPath:"http://localhost:8000/api/admin"
};
